<template>
<div>
<p>Travailler sur les propriétés de réflectivité et d'émissivité des matériaux aide également à réduire les apports solaires sur les parois opaques et à en limiter l'élévation en température. </p>

<p>Plus la couleur des matériaux tend vers une couleur claire (jusqu'à blanche), plus ils réfléchissent le rayonnement solaire direct vers l'atmosphère, et moins il stocke d'énergie sous forme de chaleur (système Cool Roof sur les toitures par exemple).</p>
</div>

</template>